import { ElementRef, OnInit, Directive } from "@angular/core";

@Directive({
	selector: "[autoFocus]",
	standalone: false
})
export class AutofocusDirective implements OnInit {
	constructor(private hostElement: ElementRef) {}
	ngOnInit(): void {
		this.focusField();
	}

	private focusField(): void {
		this.hostElement.nativeElement.focus();
	}
}
